import React from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";

const Header = () => {
  // console.log(sta'')
  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
      <Container style={{ maxWidth: "1100px" }}>
        <Navbar.Brand href="#home">Sourav</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto Navbar" style={{ Height: "90px" }}>
            <NavLink
              to="/Home"
              activeClassName="borderStyle"
              style={{
                marginRight: "35px",
                color: "white",
                textDecoration: "none",
              }}
            >
              <span className="link">Home</span>
            </NavLink>
            <NavLink
              to="/About"
              activeClassName="borderStyle"
              style={{
                marginRight: "35px",
                color: "white",
                textDecoration: "none",
              }}
            >
              <span className="link">About</span>
            </NavLink>
            <NavLink
              to="/Projects"
              activeClassName="borderStyle"
              style={{
                marginRight: "35px",
                color: "white",
                textDecoration: "none",
              }}
            >
              <span className="link">Projects</span>
            </NavLink>
            <NavLink
              to="/Contact"
              activeClassName="borderStyle"
              style={{
                marginRight: "35px",
                color: "white",
                textDecoration: "none",
              }}
            >
              <span className="link">Contact</span>
            </NavLink>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://drive.google.com/file/d/151VkM37Vyxy3blRi_Q-JJ6bAXcyN-tx4/view"
              style={{
                marginRight: "45px",
                border: "1px solid rgb(223, 92, 4)",
                textDecoration: "none",
                borderRadius: "5px",
                padding: "2px 12px",
                color: "#5aba87",
              }}
            >
              <FontAwesomeIcon icon={faFileDownload} />{" "}
              <span style={{ marginLeft: "5px" }}>Resume</span>{" "}
            </a>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
